import { DefaultButton as FabricDefaultButton, IButtonProps } from "@fluentui/react";
import * as React from "react";

export type DefaultButtonProps = IButtonProps & {
    testId?: string;
};
export const DefaultButton: React.FunctionComponent<DefaultButtonProps> = (props: DefaultButtonProps) => (
    <FabricDefaultButton {...props} data-testid={props.testId} />
);
